module.exports = __webpack_public_path__ + "img/new script.240d09ea.jpg";